<template>
  <el-dialog
    title="选择报告"
    :visible.sync="visible"
    width="960px"
    append-to-body=""
    @closed="handleClosed">
    <!-- <div class="search-form">
      <el-input
        v-model="config.vendorName"
        placeholder="请输入企业名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div> -->
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.inspectionReportId"
            :label="row.inspectionReportId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="报告编号"
        width="160"
        prop="reportNo"> </el-table-column>
      <el-table-column
        label="报告名称"
        min-width="140"
        prop="reportName"></el-table-column>
      <el-table-column
        label="样品名称"
        min-width="120"
        prop="productName"></el-table-column>
      <el-table-column
        label="企业名称"
        min-width="170"
        prop="vendorName"></el-table-column>
      <!-- <el-table-column
        label="检测机构"
        min-width="130"
        prop="sgsName"></el-table-column> -->
      <el-table-column
        label="报告图片"
        width="95"
        prop="reportImageFile">
        <template slot-scope="{ row }">
          <el-image
            style="width: 70px; height: 98.7px"
            :src="row.reportImageFile"
            :preview-src-list="[row.reportImageFile]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        label="生成时间"
        min-width="135"
        prop="createdTime">
        <template slot-scope="{ row }">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ReportSelectModal',
  components: {},
  props: {
    callback: Function,
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorId: null,
        productId: null
        // vendorName: ''
      },
      totalNum: 0,
      current: {}
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config.pageNum = 1
      this.totalNum = 0
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.inspectionReportId) {
        this.$message.error('请选择一个报告')
        return
      }
      this.callback && this.callback(this.current)
      if (this.autoClose) {
        this.toggleModal(false)
      }
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('account/getinspectionreports', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.vendorId = row.vendorId
      this.config.productId = row.productId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
